<template>
	<div class="horse-menu-mobile d-md-none">
		<div class="menu-header">
			<h2 class="menu-title text-truncate mb-0">{{ $t('global.photo') }}</h2>
			<a href="#" class="menu-icon" @click.prevent="$emit('close')">
				<font-awesome-icon :icon="['fal', 'times']" />
			</a>
		</div>
		<div class="menu-content">
			<a v-if="!horse_readonly && has_photo" href="#" class="menu-action" @click.prevent="$emit('deletePhoto')">
				<font-awesome-icon :icon="['fal', 'trash-alt']" /> {{ $t('photo.supprimer_photo_principale') }}
			</a>
			<a v-if="!horse_readonly" href="#" class="menu-action" @click.prevent="$emit('addPhoto')">
				<font-awesome-icon :icon="['fal', 'camera']" /> {{ $t('photo.ajouter_photo_principale') }}
			</a>
			<a v-if="hasNoteAccess" href="#" class="menu-action" @click.prevent="addNote">
				<font-awesome-icon :icon="['fal', 'file-alt']" /> {{ $t('notes.add_note') }}
			</a>
			<a href="#" class="menu-action" @click.prevent="addOrdonnance">
				<font-awesome-icon :icon="['far', 'file-medical-alt']" /> {{ $t('ordonnance.ajouter_ordonnance') }}
			</a>
		</div>
	</div>
</template>

<script type="text/javascript">
	export default {
		name: 'HorseMenuPhotoMobile',
		props: {
			horse_id: { type: Number, required: true },
			has_photo: { type: Boolean, default: false },
			horse_readonly: { type: Boolean, default: false }
		},
		methods: {
			addNote() {
				this.$router.push({ name: 'notesManagement', params: { horse_id: this.horse_id } })
			},
			addOrdonnance() {
				this.$router.push({ name: 'ordonnanceAjout', params: { horse_id: this.horse_id, from: this.$route.name } })
			}
		},
		computed: {
			hasNoteAccess() {
				return this.$store.state.userAccess.hasNoteAccess
			}
		}
	}
</script>
